import { Dispatch } from 'react';
import { request } from "./request";
import { SessionAction } from '../interfaces/Session';

export function getImpersonateList(dispatch: Dispatch<SessionAction>) {
  return request(dispatch, '/thicket/users', {
    method: 'GET',
  });
}